module.exports = __webpack_public_path__ + "static/img/theatre_5.a16119d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/theatre_5.jpg
// module id = qRYL
// module chunks = 3